// removed by extract-text-webpack-plugin
module.exports = {"breakpointXs":"575px","breakpointSm":"767px","breakpointMd":"991px","breakpointLg":"1199px","breakpointXl":"$breakpoint-xl"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/stylus/app.styl
// module id = E/3d
// module chunks = 54